const destructureTheDate = (timeslot) => {
  const timeslotDate = new Date(timeslot)
  const localTimeslotDate = new Date(timeslotDate.toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }))
  const year = localTimeslotDate.getFullYear()
  const month = localTimeslotDate.getMonth() + 1
  const day = localTimeslotDate.getDay()
  const date = localTimeslotDate.getDate()
  const hours = localTimeslotDate.getHours()
  const minutes = localTimeslotDate.getMinutes()
  const time = hours * 100 + minutes
  return {
    year,
    month,
    day,
    date,
    time
  }
}

const timeslotsFilterCallbacks = {
  // December 8-24, Thu-Sat, 18:00-20:00 closure + Christmas Eve (Dec 24, Wed) 18:00-20:00
  // (except Enschede, Hilversum, Almere Centrum, Delft)
  rule1: (timeslot) => {
    const { month, day, date, time } = destructureTheDate(timeslot)

    // December 8-24, Thu-Sat, 18:00-20:00
    if (month === 12 && date >= 8 && date <= 24 && (day === 4 || day === 5 || day === 6) && time >= 1800 && time <= 2000) {
      return false
    }

    // Christmas Eve (Dec 24, Wed), 18:00-20:00
    if (month === 12 && date === 24 && time >= 1800 && time <= 2000) {
      return false
    }

    return true
  },
  // Minimum time 16:00 - reservations only from 16:00 onwards (lunch blocked)
  rule2: (timeslot) => {
    const { time } = destructureTheDate(timeslot)

    if (time < 1600) return false
    return true
  },
  // Eindhoven specific closures: 17:30-20:30 on specific dates
  rule3: (timeslot) => {
    const { year, month, date, time } = destructureTheDate(timeslot)

    const EINDHOVEN_CLOSURES = [
      { year: 2025, month: 12, date: 9 },
      { year: 2025, month: 12, date: 13 },
      { year: 2025, month: 12, date: 16 },
      { year: 2026, month: 1, date: 10 },
      { year: 2026, month: 1, date: 24 },
      { year: 2026, month: 1, date: 28 },
      { year: 2026, month: 2, date: 21 },
      { year: 2026, month: 3, date: 7 },
      { year: 2026, month: 3, date: 14 },
      { year: 2026, month: 4, date: 4 },
      { year: 2026, month: 4, date: 23 },
      { year: 2026, month: 5, date: 17 }
    ]

    const isClosure = EINDHOVEN_CLOSURES.some(c =>
      c.year === year && c.month === month && c.date === date
    )

    if (isClosure && time >= 1730 && time <= 2030) return false
    return true
  },
  // Block lunch (before 16:00) on Mondays only (for Almere Centrum, Arnhem, Nijmegen)
  rule4: (timeslot) => {
    const { day, time } = destructureTheDate(timeslot)

    // Monday = 1, block lunch
    if (day === 1 && time < 1600) return false
    return true
  },
  // Block lunch (before 16:00) on Mondays and Tuesdays (for Enschede)
  rule5: (timeslot) => {
    const { day, time } = destructureTheDate(timeslot)

    // Monday = 1, Tuesday = 2, block lunch
    if ((day === 1 || day === 2) && time < 1600) return false
    return true
  },
  // Minimum time 12:00 - floor for locations with lunch access
  rule6: (timeslot) => {
    const { time } = destructureTheDate(timeslot)

    if (time < 1200) return false
    return true
  },
  // January 1 - May 21, Fri-Sat only, 18:00-20:00 block
  // (except Delft, Almere Centrum, Hilversum, Enschede, Almere Noorderplassen)
  rule7: (timeslot) => {
    const { year, month, date, day, time } = destructureTheDate(timeslot)

    // Check if date is in range: Jan 1 - May 21, 2026
    const isInRange = (year === 2026 && (
      (month >= 1 && month <= 4) ||
      (month === 5 && date <= 21)
    ))

    // Fri (5) or Sat (6), 18:00-20:00
    if (isInRange && (day === 5 || day === 6) && time >= 1800 && time <= 2000) {
      return false
    }
    return true
  },
  // Almere Noorderplassen: Jan onwards, Tue-Sun, 17:00-19:30 block
  rule8: (timeslot) => {
    const { year, month, day, time } = destructureTheDate(timeslot)

    // From January 2026 onwards
    const isInRange = (year === 2026 && month >= 1)

    // Tue-Sun (day !== 1 means not Monday), 17:00-19:30
    if (isInRange && day !== 1 && time >= 1700 && time <= 1930) {
      return false
    }
    return true
  },
  // Max 19:45 on Tue/Wed/Thu/Sun for Almere locations (Centrum + Noorderplassen)
  rule9: (timeslot) => {
    const { year, month, day, time } = destructureTheDate(timeslot)

    // From January 2026 onwards
    const isInRange = (year === 2026 && month >= 1)

    // Tue(2)/Wed(3)/Thu(4)/Sun(0), block after 19:45
    if (isInRange && [0, 2, 3, 4].includes(day) && time > 1945) {
      return false
    }
    return true
  },
  // Mother's Day: Sunday May 10, 2026, 18:00-20:00 block
  // (except Delft, Almere Centrum, Hilversum, Enschede, Almere Noorderplassen)
  rule10: (timeslot) => {
    const { year, month, date, day, time } = destructureTheDate(timeslot)

    // Mother's Day: Sunday May 10, 2026, 18:00-20:00
    if (year === 2026 && month === 5 && date === 10 && day === 0 && time >= 1800 && time <= 2000) {
      return false
    }
    return true
  }
}

const config = {
  type: 'voucherDinerdeal',
  activator: {
    type: 'notesField',
    text: 'AH 2gangen dinerdeal 2025'
  },
  startDate: '2025/11/21',
  endDate: '2026/05/21',
  excludedDates: [
    '2025-12-25',
    '2025-12-26',
    '2026-02-14',
    '2026-04-27'
  ],
  maxGroupSize: 14,
  locations: [
    {
      id: '073d8084-de0c-47b0-a1a5-8f26de05e6c6',
      name: 'Loetje Almere Centrum',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule4', 'rule6', 'rule9'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '46f6ef79-3caa-4ad7-8e4c-a0d71ded7c2d',
      name: 'Loetje Almere Noorderplassen',
      timeslotsFilterCb: (timeslot) => {
        return ['rule6', 'rule8', 'rule9'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '31c1d494-f503-4012-9e28-d489b34b8c64',
      name: "Loetje Amsterdam aan 't IJ",
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '95e356b8-100c-4d24-9114-fc01a1e4e7c5',
      name: 'Loetje Amsterdam Café',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '60516784-248d-4623-81e6-e078e21c418c',
      name: 'Loetje Amsterdam Centraal',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'bd3c7497-7dde-4707-b82f-5916d560b0d7',
      name: 'Loetje Amsterdam de Pijp',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '8c4cbf41-116d-4b65-af4f-9445c7ceb303',
      name: 'Loetje Amsterdam Oost',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'e5cb1ae5-e33e-4704-ab84-151a10fd02cc',
      name: 'Loetje Amsterdam ZuidAs',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '421c8266-67d6-4706-af6a-fa55af035ddc',
      name: 'Loetje Arnhem',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule4', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '59c148c0-82f5-453c-a8f7-a6cf7252965d',
      name: 'Loetje Bergen',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'f546558b-693d-407a-9652-3732a647d45c',
      name: 'Loetje Breda',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '2d519dcc-47d3-478a-b13f-c7892791f2b1',
      name: 'Loetje Breukelen',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '870161c9-4eed-4e96-914a-ee8dca65ec62',
      name: 'Loetje Delft',
      timeslotsFilterCb: (timeslot) => {
        return ['rule2'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '6907a272-a59d-45f6-890e-6cae57604afb',
      name: 'Loetje Den Haag Binckhorst',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'c5049038-c04d-4812-aba9-0227d692bdf6',
      name: 'Loetje Den Haag Centrum',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '1451d489-91da-45bd-b9ba-a2badf8df562',
      name: 'Loetje Eindhoven',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule3', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '30077c4b-e4b4-4696-b4c7-ecbf5a2eca54',
      name: 'Loetje Enschede',
      timeslotsFilterCb: (timeslot) => {
        return ['rule5', 'rule6'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'c42fa1a7-4555-42fc-81b5-30e8c971dd1a',
      name: 'Loetje Gorssel',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'b81893d2-89d7-44d7-ac4a-d1180a337183',
      name: 'Loetje Haarlem',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '87c967ba-6820-4c93-95ea-a5f42ce74d57',
      name: 'Loetje Hilversum',
      timeslotsFilterCb: (timeslot) => {
        return ['rule6'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '088dc63e-cd1d-4a3a-a0b1-c707a27263b9',
      name: 'Loetje Houten',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '7acd55e7-a1e9-4fa2-93d7-8c7a641d03f3',
      name: 'Loetje Huizen',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '2a42dc37-94e4-48de-9c72-d45e8f84879f',
      name: 'Loetje Laren',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '99899aa7-7c5e-4de2-873f-5378c9a587fb',
      name: 'Loetje Leeuwarden',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'bb344a63-4840-4afc-9320-4ff0d411ee85',
      name: 'Loetje Leiden',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'fc26a292-ce6f-4135-a6d7-c103ae956ef0',
      name: 'Loetje Maastricht',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '9203dd5b-93e7-4498-92bd-70e86e8cab5d',
      name: 'Loetje Nijmegen',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule4', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'e8628cef-6522-438b-a3be-02670679c9d5',
      name: 'Loetje Oegstgeest',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '28e4f8d5-6934-49c7-9730-7b49cfa4d79d',
      name: 'Loetje Ouderkerk aan de Amstel',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '9a6177e2-0d9b-48eb-84a1-fafff4074733',
      name: 'Loetje Overveen',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '214359e2-ce29-43d9-b439-5cb6765673de',
      name: 'Loetje Paterswolde',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '1334954c-211b-405f-b4a6-369a684dcb86',
      name: 'Loetje Reeuwijk',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '31cb5eee-6399-4d2a-a99d-2978aeb35007',
      name: 'Loetje Rotterdam Centrum',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '3f9cefaa-c00a-40c6-96ba-0047725c050b',
      name: 'Loetje Rotterdam Kop van Zuid',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule2', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '70d0ea6f-0da9-499f-8063-380ccf0b3e66',
      name: 'Loetje Utrecht',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: 'deda9f31-5bf1-4efa-8e1d-7dc2f1d6fd21',
      name: 'Loetje Vught',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '1909edb7-0cdb-46dc-8010-d1a8ea05bf76',
      name: 'Loetje Zeist',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    },
    {
      id: '688f61d3-278c-4283-acc3-3570e7b8c9df',
      name: 'Loetje Zwolle',
      timeslotsFilterCb: (timeslot) => {
        return ['rule1', 'rule6', 'rule7', 'rule10'].every(ruleName => timeslotsFilterCallbacks[ruleName](timeslot))
      }
    }
  ]
}

module.exports = config
